import { useMemo } from "react";

import { useClientHostname } from "@/hooks/use-client-hostname";
import { isTestEnvironmentHost } from "@/lib/test-environment";

export function useIsTestEnvironment() {
  const hostname = useClientHostname();

  return useMemo(() => isTestEnvironmentHost(hostname), [hostname]);
}
